import * as R from "ramda";
import React, { useRef } from "react";
import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";

import { noop } from "utils/General";
import { Div, Text1 } from "components/Base";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import FileViewer from "components/Global/Modals/FileViewer";
import FileViewerWrapper from "components/Global/Modals/FileViewer/Wrapper";
import File from "components/Atoms/File";

import { showModal } from "redux/modules/modal/actions";
import { actions } from "ui-kit/Form/model";
import { getValue } from "ui-kit/Form/selectors";

import { FIELD_TYPES } from "ui-kit/Form/constants";
import { WithFormInstanceConsumer } from "ui-kit/Form/View/Context";
import { CONTACTS } from "utils/standard-module-field-ids";
import * as STANDARD_MODULES from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

const decorate = R.compose(
  WithFormInstanceConsumer({ fieldType: FIELD_TYPES.FILE }),
  connect(
    (state, props) => ({
      value: getValue(state, props)
    }),
    bindInstance({
      setFieldValue: actions.setFieldValue,
      showFilePicker: actions.showFilePicker,
      showModal,
      onBlur: actions.blurField
    })
  ),
  CSSModules(css)
);

const Preview = ({
  fieldType,
  fieldId,
  value: files = [],
  isReadOnly = false,
  showFilePicker = noop,
  setFieldValue = noop,
  showModal = noop,
  onBlur = noop,
  noShadow,
  small = false,
  options = {},
  module_id = null
}) => {
  const containerRef = useRef(null);

  const forceSquareCrop =
    module_id === STANDARD_MODULES.contacts.id &&
    fieldId === CONTACTS.AVATAR_URL;
  const deleteFile = file =>
    setFieldValue(
      { remove: [file] },
      { meta: { fieldType, fieldId, containerRef } }
    );

  const showFileViewer = file => {
    showModal({
      content: (
        <FileViewer
          onFileDelete={deleteFile}
          start={files.indexOf(file)}
          files={files}
          isReadOnly={isReadOnly}
        />
      ),
      wrapper: FileViewerWrapper
    });
  };

  if (forceSquareCrop) {
    const Files = () =>
      R.map(
        file => (
          <Div mt={2}>
            <File
              key={file.id}
              file={file}
              onClick={showFileViewer}
              downloadFile={url => window.open(url, "_blank")}
              deleteFile={deleteFile}
              isReadOnly={isReadOnly}
              showBar={false}
            />
          </Div>
        ),
        files
      );

    return (
      <div
        className="ignore-react-onclickoutside preview-file-container"
        styleName={noShadow ? "containerNoShadow" : "container"}
        ref={containerRef}
        onBlur={() =>
          onBlur(null, { meta: { fieldId, fieldType, containerRef } })
        }
      >
        {!isReadOnly && R.length(files) === 0 && (
          <>
            <Text1>
              Upload a square image that can be used as a headshot. Recommended
              size is 300 x 300 px.
            </Text1>
            <div
              styleName={small ? "uploadSmall" : "upload"}
              onClick={() => {
                if (
                  R.isEmpty(files) ||
                  (!R.isEmpty(files) && R.propEq("multiple", true, options))
                ) {
                  showFilePicker(options, {
                    meta: { fieldId, fieldType, containerRef }
                  });
                }
              }}
              style={
                R.propEq("multiple", false, options) && !R.isEmpty(files)
                  ? { opacity: 0.3, cursor: "default" }
                  : {}
              }
            >
              <i
                className="material-icons"
                styleName={small ? "clipSmall" : "clip"}
                style={
                  R.propEq("multiple", false, options) && !R.isEmpty(files)
                    ? { color: "#d4d4d4" }
                    : {}
                }
              >
                attach_file
              </i>
            </div>
            <Files />
          </>
        )}

        {!isReadOnly && R.length(files) > 0 && (
          <Div display="row.space-between.center" width={1}>
            <Files />
            <Text1 textAlign="center" bold width={0.5}>
              {files[0].filename}
            </Text1>
          </Div>
        )}
      </div>
    );
  }

  return (
    <div
      className="ignore-react-onclickoutside preview-file-container"
      styleName={noShadow ? "containerNoShadow" : "container"}
      ref={containerRef}
      onBlur={() =>
        onBlur(null, { meta: { fieldId, fieldType, containerRef } })
      }
    >
      {!isReadOnly ? (
        <div
          styleName={small ? "uploadSmall" : "upload"}
          onClick={() => {
            if (
              R.isEmpty(files) ||
              (!R.isEmpty(files) && R.propEq("multiple", true, options))
            ) {
              showFilePicker(options, {
                meta: { fieldId, fieldType, containerRef }
              });
            }
          }}
          style={
            R.propEq("multiple", false, options) && !R.isEmpty(files)
              ? { opacity: 0.3, cursor: "default" }
              : {}
          }
        >
          <i
            className="material-icons"
            styleName={small ? "clipSmall" : "clip"}
            style={
              R.propEq("multiple", false, options) && !R.isEmpty(files)
                ? { color: "#d4d4d4" }
                : {}
            }
          >
            attach_file
          </i>
        </div>
      ) : null}

      {R.map(
        file => (
          <Div mt={2}>
            <File
              key={file.id}
              file={file}
              onClick={showFileViewer}
              downloadFile={url => window.open(url, "_blank")}
              deleteFile={deleteFile}
              isReadOnly={isReadOnly}
            />
          </Div>
        ),
        files
      )}
    </div>
  );
};

export default decorate(Preview);
